<script setup>
import {onMounted, ref, reactive} from "vue";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {addOnlineStoreGroup, listOnlineStoreGroup, removeOnlineStoreGroup} from "@/api/storeGroup/storeGroup.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  storeGroupName: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listOnlineStoreGroup(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    console.log("total", total.value)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.storeGroupName = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '分组名称', key: 'storeGroupName', nowrap: true },
  { title: 'English', key: 'storeGroupNameEn', nowrap: true },
  { title: '商品数量', key: 'storeGroupAmount', nowrap: true },
  { title: '创建时间', key: 'crTime', nowrap: true },
  { title: '操作', key: 'controls', width: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
/*删除操作对话框*/
const dialogConfirm = async (item) => {
  if (Number(item.storeGroupAmount) > 0) {
    ElMessage.error(`分组 “${item.storeGroupName}” 存在关联商品，需先解除关联。`)
    return
  }
  try {
    loading.value = true
    await removeOnlineStoreGroup(item.storeGroupId)
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
  loading.value = false
}

/*新建分组*/
// 新建分组弹窗状态
const open = ref(false)
// 对话框表单锚点
const dialogFormRef = ref()
// 对话框表单
const dialogForm = reactive({
  storeGroupName: null,
  storeGroupNameEn: "Coming Soon ...",
})
// 对话框表单校验规则
const dialogRules = reactive({
  storeGroupName: [
    {required: true, message: "请输入分组名称", trigger: "blur"},
  ]
})
// 关闭对话框
const closeDialog = () => {
  open.value = false
  clearDialog()
}
// 确认新建分组
const submitDialog = () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        await addOnlineStoreGroup(dialogForm)
        ElMessage.success("新建分组成功")
        await handleSearch()
        closeDialog()
      } catch (e) {
        console.log(e)
        closeDialog()
      }
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
        appendTo: "#dialog"
      })
    }
  })
}
// 清除对话框表单校验
const clearDialog = () => {
  dialogForm.storeGroupName = null
  dialogForm.storeGroupNameEn = "Coming Soon ..."
  dialogFormRef.value.clearValidate()
}
/*中英文切换输入框相关Tab*/
const storeGroupNameTab = ref("zh")
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="open = true" :disabled="!$handleHasBtnPermission('all', 'onlineStoreGroup:add')">新建分组</v-btn>
      <span class="tips_default mg_l_2">最多支持20个分组。</span>
    </div>
  </div>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <v-form>
      <v-container>
        <v-row justify="center">
          <v-col cols="4">
            <v-text-field
                v-model="formData.storeGroupName"
                placeholder="请输入分组名称"
                label="分组名称"
                variant="outlined"
                clearable
            ></v-text-field>
          </v-col>
          <v-col cols="3" offset="5">
            <v-row justify="end">
              <v-col class="flex_right" cols="6">
                <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'onlineStoreGroupPage:view')">搜索</v-btn>
              </v-col>
              <v-col class="flex_right" cols="6">
                <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'onlineStoreGroupPage:view')">重置</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除分组 “${item.storeGroupName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-show="$handleHasBtnPermission('all', 'onlineStoreGroup:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <YTFormDialog id="dialog" :open="open" :title="'新建分组'" :max-width="600">
    <template v-slot:content="{form}">
      <el-form
          ref="dialogFormRef"
          style="max-width: 100%"
          :model="dialogForm"
          :rules="dialogRules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          status-icon
          v-loading="loading"
      >
        <el-form-item label="分组名称" prop="storeGroupName">
          <el-tabs
              v-model="storeGroupNameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input maxlength="10" show-word-limit v-model="dialogForm.storeGroupName" placeholder="请输入分组名称"></el-input>
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input maxlength="30" show-word-limit v-model="dialogForm.storeGroupNameEn" placeholder="请输入分组名称"></el-input>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="5" offset="7">
          <div class="flex_right">
            <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
            <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog">确定</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
</template>

<style scoped>

</style>